import { Link } from "react-router-dom";

const CTA_IMAGE =
  "https://readdy.ai/api/search-image?query=Wide%20cinematic%20aerial%20night%20view%20of%20a%20rain-soaked%20city%20intersection%20with%20light%20trails%20and%20faint%20amber%20street%20glow%2C%20dark%20charcoal%20fog%20atmosphere%2C%20abstract%20documentary%20mood%2C%20high%20detail%20photography%20with%20deep%20shadows&width=1600&height=700&seq=blzb-cta-01&orientation=landscape";

export default function CtaSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src={CTA_IMAGE}
        alt="夜晚城市路口的长曝画面，现场信号持续回传"
        title="爆料直播 - 进入现场直播大厅"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/92 via-background-950/80 to-background-950/60" />
      <div className="stage-grid absolute inset-0 opacity-50" aria-hidden="true" />

      <div className="relative w-full px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-3 py-1.5 font-label text-[11px] tracking-wider text-primary-700">
            <i className="ri-live-line" aria-hidden="true" />
            12 路信号正在回传
          </p>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            现场不会等你，画面也不会
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            突发事态往往只有几分钟窗口期。进入直播大厅，按信号状态挑选你关心的现场，
            看实时画面、听连麦声音，第一时间掌握进展。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/live"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-radar-line text-base" aria-hidden="true" />
              立即进入直播大厅
            </Link>
            <Link
              to="/faq"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500/60 hover:text-primary-500"
            >
              <i className="ri-question-line text-base" aria-hidden="true" />
              连麦与投稿说明
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}